export default {
  API_BASE_URL: 'https://corpofood.herokuapp.com/api'
};



// WEBPACK FOOTER //
// ./src/config/config.prod.js